import AbilityScoreManager from './AbilityScoreManager';

export default AbilityScoreManager;
export { AbilityScoreManager };
